module.exports = __webpack_public_path__ + "static/media/img_female_annimation6.1b0fb27f.gif";